const parseTypeName = (type) =>
  type
    .split('_')
    .join(' ')
    .toUpperCase();

export default parseTypeName;
